var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareTwitterLionDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1200 675"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Share_Twitter_Lion_Dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7F9FA",
  d: "M0 0h1200v675H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 675,
  height: 1204,
  x: -4,
  y: 675,
  fill: "#12192B",
  rx: 4,
  transform: "rotate(-90 -4 675)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE591",
  d: "M1169.43 192.281c-6.05 95.45 88.05 134.526 126.57 138.719V-83H656.996c17.196 63.49 75.249 196.075 169.896 218.5 118.308 28.031 98.016-92.36 188.808-115 90.8-22.64 161.3 52.469 153.73 171.781",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1199FA",
  fillOpacity: 0.08,
  d: "M85.028 563.271c-24.05 32.165-52.04 51.889-84.42 27.677-32.38-24.211-35.112-66.907-11.062-99.071s66.903-68.274 99.283-44.063c32.38 24.212 20.249 83.293-3.801 115.457"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#Share_Twitter_Lion_Dark_svg__b)",
  transform: "rotate(-90 -4 510)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 397,
  height: 945,
  x: -4,
  y: 510,
  fill: "#002F61",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 397,
  height: 945,
  x: -4,
  y: 510,
  fill: "url(#Share_Twitter_Lion_Dark_svg__c)",
  fillOpacity: 0.3,
  rx: 4
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#7B849B",
  strokeWidth: 2,
  d: "M75 388h400",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1199FA",
  fillOpacity: 0.1,
  d: "M1182.4 231.698c9.88 6.977 16.02 15.259 8.95 25.27s-19.93 11.226-29.81 4.249c-9.87-6.978-21.07-19.604-13.99-29.614 7.07-10.011 24.98-6.882 34.85.095"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFD348",
  opacity: 0.06
}, /*#__PURE__*/React.createElement("circle", {
  cx: 995.502,
  cy: 632.573,
  r: 10.334,
  transform: "rotate(-90 995.502 632.573)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1036.68,
  cy: 632.573,
  r: 10.334,
  transform: "rotate(-90 1036.68 632.573)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1077.87,
  cy: 632.573,
  r: 10.334,
  transform: "rotate(-90 1077.87 632.573)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1119.14,
  cy: 632.573,
  r: 10.334,
  transform: "rotate(-90 1119.14 632.573)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1160.36,
  cy: 632.573,
  r: 10.334,
  transform: "rotate(-90 1160.36 632.573)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1201.94,
  cy: 632.573,
  r: 10.334,
  transform: "rotate(-90 1201.94 632.573)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 995.502,
  cy: 673.755,
  r: 10.334,
  transform: "rotate(-90 995.502 673.755)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1036.68,
  cy: 673.755,
  r: 10.334,
  transform: "rotate(-90 1036.68 673.755)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1077.87,
  cy: 673.755,
  r: 10.334,
  transform: "rotate(-90 1077.87 673.755)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1119.14,
  cy: 673.755,
  r: 10.334,
  transform: "rotate(-90 1119.14 673.755)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1160.36,
  cy: 673.755,
  r: 10.334,
  transform: "rotate(-90 1160.36 673.755)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1201.94,
  cy: 673.755,
  r: 10.334,
  transform: "rotate(-90 1201.94 673.755)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 995.502,
  cy: 591.39,
  r: 10.334,
  transform: "rotate(-90 995.502 591.39)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1036.68,
  cy: 591.39,
  r: 10.334,
  transform: "rotate(-90 1036.68 591.39)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1077.87,
  cy: 591.39,
  r: 10.334,
  transform: "rotate(-90 1077.87 591.39)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1119.14,
  cy: 591.39,
  r: 10.334,
  transform: "rotate(-90 1119.14 591.39)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1160.36,
  cy: 591.39,
  r: 10.334,
  transform: "rotate(-90 1160.36 591.39)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1201.94,
  cy: 591.39,
  r: 10.334,
  transform: "rotate(-90 1201.94 591.39)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 2.442,
  cy: 77.792,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 2.442 77.792)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32.94,
  cy: 77.792,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 32.94 77.792)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63.44,
  cy: 77.792,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 63.44 77.792)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.442,
  cy: 16.794,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 2.442 16.794)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32.94,
  cy: 16.794,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 32.94 16.794)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63.44,
  cy: 16.794,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 63.44 16.794)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.442,
  cy: 47.294,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 2.442 47.294)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32.94,
  cy: 47.294,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 32.94 47.294)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63.44,
  cy: 47.294,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 63.44 47.294)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.442,
  cy: 108.67,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 2.442 108.67)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.442,
  cy: 139.653,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 2.442 139.653)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.442,
  cy: 170.653,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 2.442 170.653)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32.94,
  cy: 108.67,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 32.94 108.67)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32.942,
  cy: 139.653,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 32.942 139.653)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32.942,
  cy: 170.653,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 32.942 170.653)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63.44,
  cy: 108.67,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 63.44 108.67)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63.44,
  cy: 139.653,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 63.44 139.653)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63.44,
  cy: 170.653,
  r: 7.653,
  fill: "#1199FA",
  fillOpacity: 0.1,
  transform: "rotate(-90 63.44 170.653)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 477,
  height: 522,
  x: 539,
  y: 636,
  fill: "#1199FA",
  fillOpacity: 0.15,
  rx: 4,
  transform: "rotate(-90 539 636)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M230.766 595.512c-4.047 0-7.037-3.236-7.037-7.212s2.99-7.291 7.062-7.291c2.579 0 4.178.974 5.441 2.396l-1.933 2.131c-.955-1.026-1.96-1.736-3.533-1.736-2.269 0-3.919 2-3.919 4.448 0 2.5 1.676 4.501 4.074 4.501 1.47 0 2.552-.711 3.532-1.737l1.882 1.894c-1.34 1.527-2.913 2.606-5.569 2.606m11.489 0h-3.118v-14.477h3.118v3.395c.851-2.08 2.424-3.501 4.821-3.395v3.37h-.18c-2.733 0-4.641 1.816-4.641 5.501zm21.149-14.503-6.893 18.401h-3.162l1.506-3.893-5.906-14.508h3.326l4.029 10.716 3.869-10.716zm9.204 2.764c-2.114 0-3.97 1.763-3.97 4.475s1.856 4.474 3.97 4.474c2.14 0 3.893-1.71 3.893-4.474 0-2.738-1.779-4.475-3.893-4.475m.722 11.713c-2.242 0-3.661-1.158-4.616-2.448v6.371h-3.118v-18.4h3.118v2.605c1.006-1.447 2.425-2.605 4.616-2.605 3.222 0 6.342 2.605 6.342 7.239 0 4.632-3.093 7.238-6.342 7.238m13.181-11.45v6.816c0 1.236.615 1.735 1.675 1.735h1.223v2.845h-2.133c-2.271-.007-3.884-1.037-3.884-4.081v-7.315h-1.732v-2.735h1.732v-3.818h3.119v3.818h2.898v2.735zm12.765-.237c-2.501 0-4.1 2-4.1 4.448 0 2.474 1.728 4.501 4.151 4.501 2.526 0 4.125-2 4.125-4.449 0-2.474-1.727-4.5-4.176-4.5m0 11.713c-4.151 0-7.219-3.237-7.219-7.213 0-4.001 3.093-7.291 7.27-7.291s7.245 3.238 7.245 7.239c0 3.975-3.095 7.265-7.296 7.265m13.004-2.921v1.605c0 .068-.032.13-.091.161l-1.36.802a.17.17 0 0 1-.181 0l-1.364-.802a.19.19 0 0 1-.091-.161v-1.605c0-.065.036-.126.091-.161l1.364-.802a.17.17 0 0 1 .181 0l1.36.802a.19.19 0 0 1 .091.161m24.115-8.792c-2.501 0-4.099 2-4.099 4.448 0 2.474 1.727 4.501 4.151 4.501 2.525 0 4.123-2 4.123-4.449 0-2.474-1.726-4.5-4.175-4.5m0 11.713c-4.151 0-7.219-3.237-7.219-7.213 0-4.001 3.093-7.291 7.271-7.291 4.176 0 7.244 3.238 7.244 7.239 0 3.975-3.094 7.265-7.296 7.265m-14.616-.016c-4.047-.079-6.976-3.375-6.901-7.35.075-3.973 3.127-7.23 7.199-7.15 2.578.05 4.158 1.055 5.395 2.501l-1.974 2.093c-.934-1.045-1.926-1.775-3.499-1.806-2.268-.045-3.956 1.924-4.002 4.371-.047 2.5 1.592 4.533 3.988 4.58 1.47.029 2.566-.66 3.564-1.667l1.847 1.931c-1.368 1.5-2.961 2.548-5.617 2.497m40.455-14.487c2.965 0 4.769 1.921 4.769 5.316v9.187h-3.118V587.3c0-2.211-1.006-3.395-2.759-3.395-1.701 0-2.914 1.21-2.914 3.448v8.159h-3.119v-8.239c0-2.158-1.032-3.368-2.759-3.368s-2.913 1.316-2.913 3.474v8.133h-3.12v-14.503h3.12v2.396c.876-1.237 2.063-2.396 4.151-2.396 1.959 0 3.325.974 4.047 2.447 1.11-1.473 2.552-2.447 4.615-2.447",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  fillRule: "evenodd",
  d: "M183 578.165v18.094l15.27 9.049 15.266-9.049v-18.094l-15.266-9.048zm1.344 17.301v-16.504l13.926-8.257 13.926 8.257v16.504l-13.926 8.252z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  fillRule: "evenodd",
  d: "M204.254 576.929h-11.998l-1.391 6.278H205.7zm-9.87 14.918v-4.172l-3.553-2.319-4.022 3.069 5.482 9.785h2.19l2.59-2.475v-1.243z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  fillRule: "evenodd",
  d: "M202.166 584.154h-7.77l1.309 3.508-.398 3.93h2.961l2.989-.014-.372-3.916z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  fillRule: "evenodd",
  d: "m205.72 585.328-3.513 2.347v4.172l-2.686 2.645v1.243l2.59 2.447h2.162l5.455-9.757z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "Share_Twitter_Lion_Dark_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(70.712 -450.814 462.886)scale(1158 526.16)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "Share_Twitter_Lion_Dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1200v675H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Share_Twitter_Lion_Dark_svg__b",
  width: 985,
  height: 437,
  x: -24,
  y: 97,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1445_138815"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1445_138815",
  result: "shape"
})))));
export default SvgShareTwitterLionDark;